import axios from "axios";
import React, { createContext, useState, useEffect } from "react";
import { API_ENDPOINT } from "../utils/constants";
import { getHeader } from "../utils/utils2";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Function to load user data from the backend
  // Function to load user data from the backend
  const loadUser = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${API_ENDPOINT}/admin/profile`,
        getHeader()
      );
      setUser(data);
    } catch (error) {
      console.error("Failed to load user", error);
      setUser(null);

      // Prevent infinite loop by checking the current URL
      if (error.response && [401, 403].includes(error.response.status)) {
        const currentPath = window.location.pathname;

        // Only redirect if we aren't already on logout or login
        if (
          currentPath !== "/logout" &&
          !currentPath.startsWith("/onsite-module/") &&
          currentPath !== "/login"
        ) {
          window.location.href = "/logout";
        }
      }
    } finally {
      setLoading(false);
    }
  };

  // Load user data when the component mounts
  useEffect(() => {
    loadUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, loading, reloadUser: loadUser }}>
      {children}
    </UserContext.Provider>
  );
};
